import React from "react";
import { Link } from "react-router-dom";
import { 
  FaArrowRight, 
  FaCheckCircle, 
  FaShieldAlt, 
  FaUserTie, 
  FaMicrochip, 
  FaLock,
  FaStar,
  FaTrophy,
  FaSmile,
  FaChartLine,
  FaHandshake
} from "react-icons/fa";
import "../styles/AboutSection.css";

const AboutSection = () => {
  const features = [
    {
      icon: <FaShieldAlt />,
      title: "Government Licensed",
      description: "Authorized by Govt of India with full legal compliance",
      color: "#3b82f6"
    },
    {
      icon: <FaUserTie />,
      title: "Expert Detectives",
      description: "50+ licensed professionals with years of experience",
      color: "#06d881"
    },
    {
      icon: <FaMicrochip />,
      title: "Advanced Technology",
      description: "Latest surveillance & forensic equipment",
      color: "#f59e0b"
    },
    {
      icon: <FaLock />,
      title: "100% Confidential",
      description: "Strict privacy & non-disclosure agreements",
      color: "#ef4444"
    }
  ];

  return (
    <section className="about-section">
      <div className="about-bg-pattern"></div>
      
      <div className="container">
        {/* Header with Decoration */}
        <div className="about-header">
          <div className="header-badge">
            <FaHandshake className="badge-icon" />
            <span>15+ Years of Excellence</span>
          </div>
          <h2 className="about-title">
            India's Most Trusted  <span className="title-gradient"> Detective Agency</span>
            
          </h2>
          <div className="title-decoration">
            <span className="dot"></span>
            <span className="line"></span>
            <span className="dot"></span>
          </div>
          <p className="about-subtitle">
            <strong>Indian-Detective Agency</strong> has been revolutionizing the investigation industry 
            with cutting-edge technology, unparalleled expertise, and unwavering commitment to truth.
          </p>
        </div>

        {/* Stats Section with Icons */}
        <div className="stats-wrapper">
          <div className="stat-card">
            <div className="stat-icon blue">
              <FaCheckCircle />
            </div>
            <div className="stat-number">5000+</div>
            <div className="stat-label">Cases Solved</div>
          </div>
          <div className="stat-card">
            <div className="stat-icon green">
              <FaChartLine />
            </div>
            <div className="stat-number">98%</div>
            <div className="stat-label">Success Rate</div>
          </div>
          <div className="stat-card">
            <div className="stat-icon orange">
              <FaTrophy />
            </div>
            <div className="stat-number">15+</div>
            <div className="stat-label">Years Experience</div>
          </div>
          <div className="stat-card">
            <div className="stat-icon red">
              <FaSmile />
            </div>
            <div className="stat-number">10k+</div>
            <div className="stat-label">Happy Clients</div>
          </div>
        </div>

        {/* Main Content Grid */}
        <div className="about-main-grid">
          {/* Left Side - Experience Card */}
          <div className="experience-card">
            <div className="exp-badge">Since 2016</div>
            <div className="exp-number">15<span>+</span></div>
            <div className="exp-text">Years of Excellence</div>
            <div className="exp-stats">
              <div className="exp-stat">
                <FaStar className="star-icon" />
                <span>4.9/5 Client Rating</span>
              </div>
              <div className="exp-stat">
                <FaCheckCircle className="check-icon" />
                <span>ISO Certified</span>
              </div>
            </div>
            <div className="exp-quote">
              "Truth is our only agenda"
            </div>
          </div>

          {/* Right Side - Features */}
          <div className="features-wrapper">
            <div className="features-header">
              <span className="feature-tag">Why Choose Us</span>
              <h3>What Makes Us Different?</h3>
            </div>
            <div className="features-list">
              {features.map((feature, index) => (
                <div key={index} className="feature-item">
                  <div className="feature-icon-wrapper" style={{ background: `${feature.color}15` }}>
                    <div className="feature-icon" style={{ color: feature.color }}>
                      {feature.icon}
                    </div>
                  </div>
                  <div className="feature-info">
                    <h4>{feature.title}</h4>
                    <p>{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Mission Vision Row */}
        <div className="mission-vision-row">
          <div className="mission-card">
            <div className="card-icon">🎯</div>
            <h3>Our Mission</h3>
            <p>To deliver truth with integrity using cutting-edge investigative techniques while maintaining the highest standards of confidentiality and professionalism.</p>
            <div className="card-footer">
              <span>5000+ Cases Solved</span>
            </div>
          </div>
          <div className="vision-card">
            <div className="card-icon">👁️</div>
            <h3>Our Vision</h3>
            <p>To become India's most trusted and technologically advanced detective agency, setting new benchmarks in investigative excellence.</p>
            <div className="card-footer">
              <span>50+ Expert Detectives</span>
            </div>
          </div>
          <div className="value-card">
            <div className="card-icon">⚡</div>
            <h3>Our Values</h3>
            <p>Integrity, Confidentiality, Professionalism, and Excellence in every investigation we undertake.</p>
            <div className="card-footer">
              <span>24/7 Emergency Support</span>
            </div>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="trust-badges">
          <div className="trust-badge">
            <FaStar />
            <span>4.9/5 Rating</span>
          </div>
          <div className="trust-badge">
            <FaCheckCircle />
            <span>98% Success</span>
          </div>
          <div className="trust-badge">
            <FaShieldAlt />
            <span>Govt Licensed</span>
          </div>
          <div className="trust-badge">
            <FaHandshake />
            <span>10k+ Clients</span>
          </div>
        </div>

        {/* CTA Button */}
        <div className="about-cta-wrapper">
          <Link to="/about-us" className="about-cta-button">
            Discover More About Us
            <FaArrowRight className="cta-arrow" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;